import { useContext, useEffect, useState } from "react";
import "../../DrugAssignmentBatchRelease/DrugAssignment.css";
import { Link, useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
import SearchedComponent from "../../../components/SearchedComponent";
import Loader from "../../../components/Loader";
import StyledGridComp from "../../../components/StyledGridComp";
import ResupplySwitch from "../../../components/CustomSwitch/ResupplySwitch";
import {
  fetchAllBulkSiteDataService,
  saveBulkEditSiteService,
} from "../../../services/siteManagamentService";
import { notifyError, notifySuccess } from "../../../utilities/helper";
import { MenuContext } from "../../../App";

const BulkEditSite = () => {
  const [load, setLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [rowData, setRowData] = useState([]);
  const [rowLength, setRowLength] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [canBulkUpdate, setCanBulkUpdate] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");

  const navigate = useNavigate();

  const { systemActions } = useContext(MenuContext);

  const access_token = localStorage?.getItem("access_token");
  const roleId = localStorage.getItem("roleId");
  const role = localStorage.getItem("role");
  const enrollmentAlias = localStorage.getItem("enrollmentAlias");

  useEffect(() => {
    if (page >= 0 && pageSize && access_token && roleId) {
      fetchAllSiteData(page, pageSize, access_token, debouncedSearch);
    }
  }, [debouncedSearch, roleId]);

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      let canAdd = false;
      const canUpdate = systemActions?.find(
        (item) => item?.name === "SiteBulkUpdate"
      );
      if (canUpdate) {
        canAdd = true;
      }
      setCanBulkUpdate(canAdd);
    } else if (role === "Admin") {
      setCanBulkUpdate(true);
    }
  }, [systemActions]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchedValue);
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchedValue]);

  const columns = [
    {
      field: "siteNumber",
      headerName: "Site Number",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Site Number"}</div>,
      renderCell: (params) => {
        const siteNumber = params.row.siteNumber;

        return <span>Site {siteNumber}</span>;
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Name"}</div>,
      renderCell: (params) => {
        const name = params.row.name;

        return <span>{name}</span>;
      },
    },
    {
      field: "isActive",
      headerName: "Active",
      filterable: false,
      width: 250,
      renderHeader: () => <div className="grid-heading">{"Active"}</div>,
      renderCell: (params) => {
        const isActive = params.row.isActive;

        return (
          <div style={{ marginTop: "8px" }}>
            <ResupplySwitch
              disabled={canBulkUpdate ? false : true}
              value={isActive}
              onChange={(val) =>
                handleSwitchChange(val, params.row.id, "isActive")
              }
            />
          </div>
        );
      },
    },
    {
      field: "isDrugOrderingEnabled",
      headerName: "Drug Ordering Enabled",
      width: 250,
      filterable: false,
      renderHeader: () => (
        <div className="grid-heading">{"Drug Ordering Enabled"}</div>
      ),
      renderCell: (params) => {
        const isDrugOrderingEnabled = params.row.isDrugOrderingEnabled;

        return (
          <div style={{ marginTop: "8px" }}>
            <ResupplySwitch
              disabled={canBulkUpdate ? false : true}
              value={isDrugOrderingEnabled}
              onChange={(val) =>
                handleSwitchChange(val, params.row.id, "isDrugOrderingEnabled")
              }
            />
          </div>
        );
      },
    },
    {
      field: "isRandomizationOpen",
      headerName: "Randomization Open",
      filterable: false,
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Randomization Open"}</div>
      ),
      renderCell: (params) => {
        const isRandomizationOpen = params.row.isRandomizationOpen;

        return (
          <div style={{ marginTop: "8px" }}>
            <ResupplySwitch
              disabled={canBulkUpdate ? false : true}
              value={isRandomizationOpen}
              onChange={(val) =>
                handleSwitchChange(val, params.row.id, "isRandomizationOpen")
              }
            />
          </div>
        );
      },
    },
    {
      field: "isScreeningOpen",
      headerName: "Screening Open",
      filterable: false,
      width: 250,
      renderHeader: () => (
        <div className="grid-heading">{"Screening Open"}</div>
      ),
      renderCell: (params) => {
        const isScreeningOpen = params.row.isScreeningOpen;

        return (
          <div style={{ marginTop: "8px" }}>
            <ResupplySwitch
              disabled={canBulkUpdate ? false : true}
              value={isScreeningOpen}
              onChange={(val) =>
                handleSwitchChange(val, params.row.id, "isScreeningOpen")
              }
            />
          </div>
        );
      },
    },
  ];

  const handleSwitchChange = (value, id, field) => {
    setRowData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const fetchAllSiteData = async (
    page,
    pageSize,
    access_Token,
    debouncedSearch = ""
  ) => {
    setLoad(true);
    try {
      const res = await fetchAllBulkSiteDataService(
        1,
        100,
        access_Token,
        roleId,
        debouncedSearch
      );
      if (res?.status === 200) {
        setRowData(res?.data?.result);
        setRowLength(res?.data?.totalCount);
        setLoad(false);
      } else if (res?.status == 401) {
        navigate("/unauthorize");
      }
    } catch (err) {
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  const handleSearch = (e) => {
    setSearchedValue(e.target.value);
  };

  const saveDetails = async () => {
    try {
      setLoad(true);
      const res = await saveBulkEditSiteService(
        access_token,
        rowData,
        roleId,
        enrollmentAlias
      );
      if (res?.status === 200) {
        setLoad(false);
        notifySuccess("Site details updated successfully");
        fetchAllSiteData(page, pageSize, access_token, debouncedSearch);
      } else {
        setLoad(false);
        notifyError("Failed to update site details");
      }
    } catch (err) {
      console.log("ERR", err);
      setLoad(false);
      if (err?.status == 401) {
        navigate("/unauthorize");
      }
    }
  };

  return (
    <>
      <div className="content-body">
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/site-management">
            Site Management
          </Link>{" "}
          |{" "}
          <Link className="bread-crumbs-link" to="/bulk-edit-site">
            Bulk Site Management
          </Link>{" "}
          -{" "}
          <b style={{ color: "gray" }}>
            {localStorage?.getItem("studyName")}
          </b>
        </p>
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "100%", margin: "0 auto" }}
        >
          <Grid2 item md={6} sx={{ width: "100%" }}>
            <p className="page-heading">Bulk Site Management</p>
          </Grid2>
        </Grid2>

        <div
          className="search-bar-container"
          style={{
            display: "flex",
            justifyContent: "end",
            margin: "-1% 1% 1% 1%",
          }}
        >
          <SearchedComponent
            handleSearch={handleSearch}
            placeholder="Sites"
            searchedValue={searchedValue}
          />
        </div>

        {load ? (
          <Loader />
        ) : (
          <StyledGridComp
            rows={rowData}
            columns={columns}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            isPaginationClientSide={true}
            length={rowLength}
          ></StyledGridComp>
        )}

        <Grid2
          alignItems={"end"}
          justifyContent="end"
          container
          gap={3}
          sx={{ marginTop: "2%" }}
        >
          <Grid2 item md={6}>
            <button
              type="button"
              className="create-btn-outlined"
              onClick={(e) => {
                e.preventDefault();
                navigate("/site-management");
              }}
            >
              Back
            </button>
          </Grid2>
          <Grid2 item md={6}>
            <button
              onClick={saveDetails}
              disabled={canBulkUpdate ? false : true}
              className={canBulkUpdate ? "create-btn" : "disabled-btn"}
            >
              Save
            </button>
          </Grid2>
        </Grid2>
      </div>
    </>
  );
};

export default BulkEditSite;
